import { styled } from 'baseui'

export const LegacyColumns = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '@media screen and (min-width: 1200px)': {
    flexDirection: 'row',
  },
})

export const LegacyColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  marginBottom: '1rem',
  marginLeft: '1rem',
  ':last-child': {
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    marginLeft: '1rem',
  },
  '@media screen and (min-width: 1200px)': {
    width: '100%',
    marginLeft: '1rem',
  },
})

export const ShellColumnStack = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  minWidth: 0,
})
